import {
  CLEAR_PROPS_SUCCESS,
  CREATE_TPWA_SUCCESS,
  FETCH_QUOTATIONS_SUCCESS,
  FETCH_TPW_SNO_SUCCESS,
  SAVE_TPWA_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  resource: {},
  query: {},
  tpwSno : '',
  quotations: [],
  disable : false,
  quote: null,
  tpwNo : '',
  history: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_TPWA_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case CREATE_TPWA_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case CLEAR_PROPS_SUCCESS: {
      return {
        ...state,
        resource: {},
        query: {},
        tpwSno : '',
        quotations: [],
        disable : false,
        quote: null,
        history: [],
        tpwNo: ''
      }
    }

    case FETCH_QUOTATIONS_SUCCESS: {
      const query = {...state.query};
      return {
        ...state,
        query: query,
        quotations: action.data,
        total: action.count,
        disable: action.disable,
        quote: action.quote,
        history: action.history,
        tpwNo : action.tpwNo || ''
      }
    }

    case FETCH_TPW_SNO_SUCCESS: {
      return {
        ...state,
        tpwSno: action.data,
      }
    }
    default:
      return state;
  }
}
